var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isNewBadgeVisible
    ? _c("div", [
        _c("span", { staticClass: "new-badge" }, [
          _vm._v(" " + _vm._s(_vm.$t("Common.System.newLabel")) + " "),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }